import React from 'react';
import { useTranslation } from 'react-i18next';
import {
  faTag, faStore, faListOl, faCalendarDay, faScaleBalanced, faArrowTrendUp, faClockRotateLeft, faBoxOpen,
} from '@fortawesome/free-solid-svg-icons';
import SpecGrid from './SpecGrid';
import {
  priceRangeText, cheapestSellerText, cheapestOfferUrl, offerCountText,
  asOfText, unitPriceText, segmentMedianText, trend30dText,
  priceHistoryText, availabilityText,
} from '../utils/marketStats';

// Widoczny blok "Sytuacja rynkowa" na stronie modelu — renderuje wyłącznie to,
// co przyszło w market_stats z API. Żadnych obliczeń/interpretacji po stronie frontu.
const MarketStats = ({ marketStats, category }) => {
  const { t } = useTranslation('model');
  if (!marketStats) return null;

  const cheapestSeller = cheapestSellerText(marketStats);
  const offerUrl = cheapestOfferUrl(marketStats);
  const cheapestValue = cheapestSeller ? (
    <span className="inline-flex flex-wrap items-center gap-2">
      {cheapestSeller}
      {offerUrl && (
        <a
          href={offerUrl}
          target="_blank"
          rel="noopener noreferrer nofollow"
          className="text-xs font-semibold text-blue-600 hover:underline"
        >
          {t('zobacz_oferte')}
        </a>
      )}
    </span>
  ) : null;

  const items = [
    { icon: faTag, label: t('rynek.cena'), value: priceRangeText(marketStats) },
    { icon: faStore, label: t('rynek.najnizej'), value: cheapestValue },
    { icon: faListOl, label: t('rynek.liczba_ofert'), value: offerCountText(marketStats) },
    { icon: faCalendarDay, label: t('rynek.stan_na'), value: asOfText(marketStats) },
    { icon: faTag, label: t('rynek.cena_jednostkowa'), value: unitPriceText(marketStats) },
    { icon: faScaleBalanced, label: t('rynek.cena_vs_rynek'), value: segmentMedianText(marketStats, category) },
    { icon: faArrowTrendUp, label: t('rynek.trend_30'), value: trend30dText(marketStats) },
    { icon: faClockRotateLeft, label: t('historia_ceny'), value: priceHistoryText(marketStats) },
    { icon: faBoxOpen, label: t('pole.dostepnosc'), value: availabilityText(marketStats) },
  ];

  const hasAny = items.some((it) => it.value !== null && it.value !== undefined && it.value !== '');
  if (!hasAny) return null;

  return (
    <div className="max-w-7xl mx-auto px-4 md:px-8 mt-6">
      <div className="bg-white rounded-2xl border border-gray-200 shadow-sm p-5 md:p-7">
        <div className="flex items-center gap-2 mb-3">
          <h2 className="text-sm font-bold text-gray-900">{t('rynek.tytul')}</h2>
          <span className="text-[11px] px-2 py-0.5 rounded-md bg-gray-100 text-gray-500">{t('rynek.zrodlo')}</span>
        </div>
        <SpecGrid items={items} />
      </div>
    </div>
  );
};

export default MarketStats;
